import Link from "next/link";
import { useRouter } from "next/router";
import { IRoamingInternationalCountry } from "@nju/data-access-portal-dashboard";
import { portalRoutes } from "@nju/routes";
import { A, Separator, Text } from "@nju/ui";
import { IPackageType } from "../types";

interface ISelectedCountryDetailsProps {
  selectedCountry: IRoamingInternationalCountry;
  packageType?: IPackageType;
  withRoamingZone?: boolean;
}

export function SelectedCountryDetails({
  selectedCountry,
  packageType = "STANDARD",
  withRoamingZone = true,
}: ISelectedCountryDetailsProps) {
  const showAreaInfo = packageType === "STANDARD";
  const roamingZone =
    packageType === "STANDARD"
      ? selectedCountry.zones.find((zone) => {
          return !zone.isPromo;
        })?.displayName.pl
      : selectedCountry.zones.find((zone) => {
          return zone.isPromo;
        })?.displayName.pl;
  const router = useRouter();
  const { userId } = portalRoutes.mojeKonto.uslugiDodatkowe.index
    .input(router.query)
    .unwrap();

  return (
    <>
      <Text display="block" size={{ "@onlyMobile": "s", "@fromTablet": "m" }}>
        wybrany kraj
      </Text>
      <Text
        display="block"
        size={{ "@onlyMobile": "s", "@fromTablet": "l" }}
        weight="bold"
      >
        {selectedCountry.displayName.pl}
      </Text>
      <Separator size="m" />
      {withRoamingZone && (
        <Text
          className="mb-4"
          display="block"
          size={{
            "@fromTablet": "keySM",
            "@onlyMobile": "xl",
          }}
          tone="accent"
          weight="bold"
        >
          {roamingZone}
        </Text>
      )}
      {showAreaInfo && (
        <>
          <Text
            display="block"
            size={{
              "@fromTablet": "l",
              "@onlyMobile": "m",
            }}
          >
            W ramach tej strefy, z pakietu możesz korzystać jeszcze w wielu
            innych krajach.
          </Text>
          <Link
            href={portalRoutes.mojeKonto.uslugiDodatkowe.roaming.strefy.get({
              ...(userId && { userId }),
              country: selectedCountry.displayName.pl,
              zone: selectedCountry.zones.find((zone) => {
                return !zone.isPromo;
              })?.name,
            })}
            passHref={true}
          >
            <A display="block" size="inline" variant="neutral">
              <Text withUnderline={true}>sprawdź</Text>
            </A>
          </Link>
        </>
      )}
    </>
  );
}
